<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <template slot="header">
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-setting" v-if="!listen" @click="startListening">
                                    <i class="icon-control-play"></i>
                                    {{ $t('start') }}
                                </b-link>
                                <b-link class="card-header-action btn-setting" v-if="listen" @click="startListening">
                                    <i class="icon-control-pause"></i>
                                    {{ $t('listeningRequests') }}
                                </b-link>
                                <b-link class="card-header-action btn-setting" @click="items = []">
                                    <i class="icon-trash"></i>
                                    {{ $t('clear') }}
                                </b-link>
                            </div>
                        </template>
                        <!-- <b-form-group
                            label="Requests"
                            label-for="test"
                            :label-cols="1"
                            :horizontal="false">
                            <c-switch class="mx-1" color="success" variant="pill" :label="true" dataOn="Dbg" dataOff="Live" v-model="showTest"/>
                        </b-form-group> -->
                        <b-table responsive="sm" :items="itemsFiltered" :fields="fields"
                            @row-clicked="inspectRequest"></b-table>

                        <main-dialog title="Inspect request" v-model="inspect.show" size="lg">
                            <InputField type="text" :label="this.$t('requestUUID')"
                                :value="inspect.request.request_uuid" :rules="{ length: { min: 1 } }" :disabled="true" />

                            <InputField type="text" :label="this.$t('statusCode')" :value="inspect.request.status"
                                :rules="{ length: { min: 1 } }" :disabled="true" />

                            <InputField type="text" :label="this.$t('method')" :value="inspect.request.method"
                                :rules="{ length: { min: 1 } }" :disabled="true" />

                            <InputField type="text" :label="this.$t('uri')" :value="inspect.request.uri"
                                :rules="{ length: { min: 1 } }" :disabled="true" />
                            <b-form-group :label="this.$t('request')" label-for="test" :label-cols="2"
                                :horizontal="false">
                                <b-textarea :disabled=true :value="inspect.request.data" style="min-height: 300px">
                                </b-textarea>
                            </b-form-group>

                            <b-form-group :label="this.$t('responseBody')" label-for="test" :label-cols="2"
                                :horizontal="false">
                                <b-textarea :disabled=true
                                    :value="JSON.stringify(JSON.parse(inspect.request.response_body), null, 2)"
                                    style="min-height: 150px"></b-textarea>
                            </b-form-group>
                        </main-dialog>

                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Input from "@/components/form/Input"

export default {
    name: "Requests",
    components: {
        cSwitch,
        InputField: Input,
    },
    data: function () {
        return {
            socket: null,
            listen: false,
            items: [],
            showTest: false,
            inspect: {
                show: false,
                request: {
                    response_body: null
                }
            },
            fields: [
                {
                    key: "request_uuid",
                    sortable: true
                },
                {
                    key: "client_id",
                    sortable: true
                },
                {
                    key: "status",
                    sortable: true
                },
                {
                    key: "method",
                    sortable: true
                },
                {
                    key: "uri",
                    sortable: true
                }
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            disableLoader: false
        }
    },
    computed: {
        itemsFiltered() {
            return this.items.filter(i => {
                return this.showTest == i.is_test
            })
        },
    },
    methods: {
        startListening() {
            if (this.listen) {
                this.socket.close()
                this.listen = false
            } else {
                try {
                    var self = this

                    self.socket = new WebSocket(process.env.VUE_APP_EVENT_SERVER_HOST + '/api/' + this.$store.getters.getCurrentProject.uuid);

                    self.socket.addEventListener('error', function (event) {
                        self.listen = false
                        self.$mainDialog.msgBoxOk(this.$t('debuggerError'))
                    })

                    self.socket.addEventListener('message', function (event) {
                        let data = JSON.parse(event.data)

                        self.items.unshift(data)
                    })

                    self.socket.addEventListener('open', function (event) {
                        self.listen = true
                    })

                } catch (err) {
                    this.listen = false

                    this.$bvToast.toast("Failed to attached listener", {
                        variant: 'danger',
                        title: "Error"
                    })
                }
            }

        },

        inspectRequest(item) {
            this.inspect.show = true
            this.inspect.request = item
        }
    },

    mounted() {

    },

    destroyed() {
        if (this.socket !== null)
            this.socket.close()
    }
}
</script>
